import React from 'react';
import { RawTrader, TraderDerivation, ProfileTabType } from './types';
import { TONE } from './constants';
import { ProfileHero } from './ProfileHero';
import { InsightBanner } from './InsightBanner';
import { OverviewTab } from './OverviewTab';
import { AnalyticsTab } from './AnalyticsTab';
import { RiskTab } from './RiskTab';
import { HistoryTab } from './HistoryTab';
import { ReviewsTab } from './ReviewsTab';

interface ProfileViewProps {
  trader: RawTrader;
  derivation: TraderDerivation;
  tab: ProfileTabType;
  onTabChange: (tab: ProfileTabType) => void;
  onBack: () => void;
}

export const ProfileView: React.FC<ProfileViewProps> = ({
  trader,
  derivation,
  tab,
  onTabChange,
  onBack,
}) => {
  const riskLabel = trader.risk >= 85 ? 'Thấp' : trader.risk >= 65 ? 'Trung bình' : 'Cao';
  const riskTone = trader.risk >= 85 ? TONE.good : trader.risk >= 65 ? TONE.warn : TONE.bad;

  return (
    <div>
      <ProfileHero
        trader={trader}
        derivation={derivation}
        riskTone={riskTone}
        riskLabel={riskLabel}
        tab={tab}
        onTabChange={onTabChange}
        onBack={onBack}
      />

      <InsightBanner trader={trader} />

      {tab === 'ov' && (
        <OverviewTab
          trader={trader}
          derivation={derivation}
          riskTone={riskTone}
          riskLabel={riskLabel}
        />
      )}

      {tab === 'an' && (
        <AnalyticsTab
          trader={trader}
          derivation={derivation}
        />
      )}

      {tab === 'rk' && (
        <RiskTab
          trader={trader}
          derivation={derivation}
          riskTone={riskTone}
          riskLabel={riskLabel}
        />
      )}

      {tab === 'hs' && (
        <HistoryTab
          trader={trader}
          derivation={derivation}
        />
      )}

      {tab === 'rv' && (
        <ReviewsTab
          trader={trader}
          derivation={derivation}
        />
      )}
    </div>
  );
};

